<template>
  <div>
    <el-select
      v-if="!disabled"
      v-loading="loading"
      :value="selectedDomain"
      :placeholder="$t('domain.chooseDomain')"
      @input="handleSelectDomain"
    >
      <el-option-group v-if="domains.length" :label="$t('domain.chooseDomain')">
        <el-option v-for="domain in domains" :key="domain.id" :label="domain.name" :value="domain.id" />
      </el-option-group>
      <el-option-group v-else :label="$t('domain.noData')" />
      <el-option v-show="domains.length > 1" :label="$t('domain.all')" :value="-1" />
    </el-select>
    <span v-if="disabled" :value="selectedDomainName">
      {{ selectedDomainName }}
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    domains() {
      return this.$store.state.authentication.domains;
    },
    disabled() {
      return this.$store.getters['disableDomainChange'];
    },
    domainID() {
      return +this.$store.getters['domain/getCurrentDomainID'];
    },
    selectedDomainName: {
      get: function() {
        const domainID = +this.$store.getters['domain/getCurrentDomainID'];
        const domain = this.$store.getters['domain/getLoadedItemByID'](domainID);
        return domain && domain.name;
      }
    },
    selectedDomain: {
      get: function() {
        const domainID = this.$store.getters['domain/getCurrentDomainID'];
        if (domainID === 0) {
          return void 0;
        } else {
          return domainID;
        }
      }
    }
  },
  watch: {
    domainID(domainID) {
      this.update();
    }
  },
  created() {
    this.update();
  },
  methods: {
    update() {
      if (
        this.domainID !== this.$store.getters['domain/ALL_DOMAINS'] &&
        !this.domains.some(e => +e.id === this.domainID)
      ) {
        this.$store.dispatch('domain/clearCurrentDomainID');
      }
    },
    handleSelectDomain(domainID) {
      this.$store.dispatch('domain/setCurrentDomainID', domainID);
    }
  }
};
</script>
